import Input from "../../../../Core/Fields/Floating/Input";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import { useEffect, useState } from "react";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
const Tab2 = ({ SupplierPrimaryAddress, SupplierPrimaryContact, IdData }) => {
	// Helper function to format a single address object into a string.
	const formatAddress = (address) => {
		// Check if the address object and its properties exist before formatting.
		if (!address) return "";

		const name = address.name || "";
		const line1 = address.address_line1 || "";
		const line2 = address.address_line2 || "";
		const city = address.city || "";
		const state = address.state || "";
		const country = address.country || "";
		const pincode = address.pincode || "";

		// Join the city, state, country, and pincode with a comma and space.
		const cityStateCountryPincode = [city, state, country, pincode]
			.filter(Boolean)
			.join(", ");

		return `${name}\n${line1}\n${line2}\n${cityStateCountryPincode}`;
  };
  function formatContacts(contact) {
  // Use the map function to transform each contact object into a formatted string.
    // Extract the required properties from each contact object.
    const email = contact.email_id || "";
    const mobile = contact.mobile_no|| "";
    const phone = contact.phone || ""
    console.log("Contaxttt",contact);
    
    // Use a template literal to construct the formatted string.
    return `Email: ${email}\nMobile: ${mobile}\nPhone: ${phone}`;
}
  
  const [formattedAddresses, setFormattedAddresses] = useState("");
  const [formattedContact, setFormattedContact] = useState("");

  useEffect(() => {
    const adrlist =
      SupplierPrimaryAddress.SupplierPrimaryAddress_list.map(formatAddress);
    const x = adrlist.join("\n\n");
    const contlist =
      SupplierPrimaryContact.SupplierPrimaryContact_list.map(formatContacts);
    const y = contlist.join("\n\n");
    setFormattedAddresses(x);
    setFormattedContact(y)
  }, [SupplierPrimaryContact.SupplierPrimaryContact_list,SupplierPrimaryAddress.SupplierPrimaryAddress_list]); 

	return (
		<>
			<div
				className="row mb-3"
				style={{ border: "1px solid #00000059", borderRadius: "5px" }}
			>
				<div className="col-12">
					<p className="boxLabel m-0">Primary Address and Contact</p>
				</div>

				<div className="col-6">
					<div
						className={
							SupplierPrimaryAddress.Error ? `mb-2 errorborder` : `mb-2`
						}
					>
						{SupplierPrimaryAddress.SupplierPrimaryAddress_list.length > 0 ? (
              <>
                <div className="flex: 1 1 0%">

								<Textarea
									label="Primary Address"
									style={{
										whiteSpace: "pre-line",
										backgroundColor: "#f8f6f6",
                    // width: "655px",
                    // height: "500px",//
									}}
									value={formattedAddresses}
                  readOnly
								/>
                </div>
							</>
						) : (
							<>
								<Input
									label="Supplier Primary Address"
									readOnly
									value={"No Address Linked with Supplier"}
									style={{ height: "30px" }}
								/>
							</>
						)}

						<p
							style={{
								paddingLeft: "14px",
								paddingRight: "14px",
								fontWeight: 400,
								fontSize: "9px",
								letterSpacing: "0",
								color: "#00000099",
								lineHeight: "2",
								fontFamily: "Roboto, sans-serif",
							}}
						>
							Reselect, if the chosen address is edited after save
						</p>
					</div>
				</div>
				<div className="col-6">
					<div
						className={
							SupplierPrimaryContact.Error ? `mb-2 errorborder` : `mb-2`
						}
					>
						{SupplierPrimaryContact.SupplierPrimaryContact_list.length > 0 ? (
              <>
                <div className="flex: 1 1 0%">

								<Textarea
									label="Primary Contact"
									style={{
										whiteSpace: "pre-line",
										backgroundColor: "#f8f6f6",
                    // width: "655px",
                    // height: "500px",//
									}}
									value={formattedContact}
                  readOnly
								/>
                </div>
							</>
						) : (
							<>
								<Input
									label="Supplier Primary Address"
									readOnly
									value={"No Contact Linked with Supplier"}
									style={{ height: "30px" }}
								/>
							</>
						)}

						<p
							style={{
								paddingLeft: "14px",
								paddingRight: "14px",
								fontWeight: 400,
								fontSize: "9px",
								letterSpacing: "0",
								lineHeight: "2",
								color: "#00000099",
								fontFamily: "Roboto, sans-serif",
							}}
						>
							Reselect, if the chosen address is edited after save
						</p>
					</div>
				</div>
			</div>
			<div className="mt-3">
				<ActivityCard doctype="Supplier" docname={IdData} />
			</div>
		</>
	);
};

export default Tab2;
